import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { OrderDetailView } from '@/modules/orders/views/OrderDetailView';

export const Route = createFileRoute('/_app/orders/$orderId')({
   validateSearch: z.object({ mode: z.enum(['view', 'edit']).optional().catch(undefined) }),
   component: OrderDetailView
});
